<template>
    <div id="loopContainer">
        <div id="loopSeat"></div>
        <div id="loopBox">
            <el-carousel trigger="click" height="100%">
                <el-carousel-item>
                    <div id="itemOne">
                        <div class="aniWapper">
                            <div id="page1LeftTop">
                                <span class="aniBox" id="ani1"></span>
                                <span class="aniBox" id="ani2"></span>
                                <span class="aniBox" id="ani3"></span>
                                <span class="aniBox" id="ani4"></span>
                            </div>
                            <div id="pageRgithTop">
                                <span class="aniBox" id="ani5"></span>
                                <span class="aniBox" id="ani6"></span>
                                <span class="aniBox" id="ani7"></span>
                                <span class="aniBox" id="ani8"></span>
                            </div>
                            <div id="pageBottom">
                                <span class="aniBox" id="ani9"></span>
                                <span class="aniBox" id="ani10"></span>
                                <span class="aniBox" id="ani11"></span>
                                <span class="aniBox" id="ani12"></span>
                                <span class="aniBox" id="ani13"></span>
                                <span class="aniBox" id="ani14"></span>
                                <span class="aniBox" id="ani15"></span>
                                <span class="aniBox" id="ani16"></span>
                                <span class="aniBox" id="ani17"></span>
                            </div>
                        </div>
                        <img src="../../assets/imgs/home/order1.png" class="loopImg">
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div id="itemTwo">
                        <img src="../../assets/imgs/home/order2.png" class="loopImg">
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div id="itemThree">
                        <img src="../../assets/imgs/home/ani/ani5.png" id="page2Rotate">
                        <img src="../../assets/imgs/home/order3.png" class="loopImg">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen1',
}
</script>

<style scoped>
    #loopContainer{
        border-top: 1px solid #fff;
        position: relative;
    }
    #itemOne{
        background: url(../../assets/imgs/home/order1bg.png);
        background-size: 100% 100%;
        position: relative;
    }
    #itemTwo{
        background: url(../../assets/imgs/home/order2bg.png);
        background-size: 100% 100%;
    }
    #itemThree{
        /* background: url(../../assets/imgs/home/order3bg.png);
        background-size: 100% 100%; */
        background: #151053;
    }
    #loopSeat{
        width:100%;
        height:0;
        overflow:hidden;
        padding-bottom:calc(46.75% + 50px);
    }
    #loopBox{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
    }
    #loopBox div,
    .el-carousel__container{
        height: 100% !important;
    }
    .loopImg{
        width: 100%;
        margin-top: 50px;
    }
    /* 动效 */
    .aniWapper{
        position: absolute;
        width: 100%;
    }
    /* page1 */
    .aniBox{
        display: inline-block;
        position: absolute;
    }
    #ani1{
        width: 2px;
        height: 60px;
        background: -webkit-linear-gradient(#005154, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#005154, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#005154, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#005154, #001322);
        right: 42%;
        top: 18%;
         animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani2{
        width: 15px;
        height: 15px;
        border-radius: 50% 50%;
        background: -webkit-linear-gradient(#018d8c, #025357); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#018d8c, #025357); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#018d8c, #025357); /* Firefox 3.6 - 15 */
        background: linear-gradient(#018d8c, #025357);
        right: 43.5%;
        animation:ani2 7s infinite alternate;
	    -webkit-animation:ani2 7s infinite alternate;
    }
    #ani3{
        width: 2px;
        height: 50px;
        background: -webkit-linear-gradient(#007e7f, #001a29); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#007e7f, #001a29); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#007e7f, #001a29); /* Firefox 3.6 - 15 */
        background: linear-gradient(#007e7f, #001a29);
        right: 45.5%;
        animation:ani34 8s linear infinite;
	    -webkit-animation:ani34 8s linear infinite;
    }
    #ani4{
        width: 28px;
        height: 40px;
        background: url(../../assets/imgs/home/ani/ani3.png);
        background-size: 100% 100%;
        right: 47%;
        animation:ani34 10s linear infinite;
	    -webkit-animation:ani34 10s linear infinite;
    }
    #ani5{
        width: 22px;
        height: 22px;
        border-radius: 50% 50%;
        background: url(../../assets/imgs/home/ani/ani4.png);
        background-size: 100% 100%;
        right: 15%;
        margin-top: -3.5%;
        animation:ani2 5s infinite alternate;
	    -webkit-animation:ani2 5s infinite alternate;
    }
    #ani6{
        width: 38px;
        height: 50px;
        right: 10%;
        margin-top: 3.5%;
        background: url(../../assets/imgs/home/ani/ani3.png);
        background-size: 100% 100%;
        animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani7,#ani8{
        width: 2px;
        animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani7{
        height: 45px;
        right: 11.5%;
        margin-top:10%;
        background: -webkit-linear-gradient(#008999, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#008999, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#008999, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#008999, #001322); 
    }
    #ani8{
        height: 58px;
        right: 10%;
        margin-top:9%;
        background: -webkit-linear-gradient(#005e6a, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#005e6a, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#005e6a, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#005e6a, #001322);
    }
    #ani9{
        width: 50px;
        height: 100px;
        background: url(../../assets/imgs/home/ani/ani2.png);
        background-size: 100% 100%;
        right: 45%;
        animation:ani10 7s linear infinite;
	    -webkit-animation:ani10 7s linear infinite;
    }
    #ani10{
        width: 2px;
        height: 45px;
        right: 41%;
        margin-top: 32%;        
        background: -webkit-linear-gradient(#008999, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#008999, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#008999, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#008999, #001322); 
        animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani11{
        width: 40px;
        height: 42px;
        background: url(../../assets/imgs/home/ani/ani1.png);
        background-size: 100% 100%;
        right: 13%;
        bottom: 17%;
        animation:ani11 5s linear infinite;
	    -webkit-animation:ani11 5s linear infinite;
    }
    #ani12{
        width: 2px;
        height: 45px;
        right: 32.5%;
        margin-top: 35%;     
        background: -webkit-linear-gradient(#008999, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#008999, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#008999, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#008999, #001322); 
        animation:ani1 7s linear infinite;
	    -webkit-animation:ani1 7s linear infinite;
    }
    #ani13{
        width: 2px;
        height: 40px;
        right: 33.5%;
        margin-top: 38%;     
        background: -webkit-linear-gradient(#0c555f, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#0c555f, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#0c555f, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#0c555f, #001322); 
         animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani14{
        width: 2px;
        height: 45px;
        right: 20%;
        margin-top: 32%;      
        background: -webkit-linear-gradient(#008999, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#008999, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#008999, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#008999, #001322); 
        animation:ani1 7s linear infinite;
	    -webkit-animation:ani1 7s linear infinite;
    }
    #ani15{
        width: 2px;
        height: 45px;
        right: 21%;
        margin-top: 35%;      
        background: -webkit-linear-gradient(#008999, #001322); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#008999, #001322); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#008999, #001322); /* Firefox 3.6 - 15 */
        background: linear-gradient(#008999, #001322); 
         animation:ani1 5s linear infinite;
	    -webkit-animation:ani1 5s linear infinite;
    }
    #ani16{
        width: 15px;
        height: 15px;
        border-radius: 50% 50%;
        background: -webkit-linear-gradient(#018d8c, #025357); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#018d8c, #025357); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#018d8c, #025357); /* Firefox 3.6 - 15 */
        background: linear-gradient(#018d8c, #025357);
        right: 17.5%;
        bottom: 15%;
        animation:ani11 10s infinite alternate;
	    -webkit-animation:ani11 10s infinite alternate;
    }
    #ani17{
        width: 15px;
        height: 15px;
        border-radius: 50% 50%;
        background: -webkit-linear-gradient(#018d8c, #025357); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#018d8c, #025357); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#018d8c, #025357); /* Firefox 3.6 - 15 */
        background: linear-gradient(#018d8c, #025357);
        right: 35%;
        bottom: 6%;
        animation:ani11 5s infinite alternate;
	    -webkit-animation:ani11 5s infinite alternate;
    }
    /* 动画 */
    @keyframes ani1{
        0%{
            top: 22%;
            opacity: 0;
        }
        50%{
            top: 18%;
            opacity: 1;
        }
        100%{
            top: 14%;
            opacity: 0;
        }
    }
    @-webkit-keyframes ani1{
        0%{
            top: 22%;
            opacity: 0;
        }
        50%{
            top: 18%;
            opacity: 1;
        }
        100%{
            top: 14%;
            opacity: 0;
        }
    }
    @keyframes ani2{
        0%{
            top: 29%;
            opacity: 0;
        }
        100%{
            top: 25%;
        }
    }
    @-webkit-keyframes ani2{
        0%{
            top: 29%;
            opacity: 0;
        }
        100%{
            top: 25%;
        }
    }
    @keyframes ani34{
        0%{
            top: 32%;
            opacity: 0;
        }
        50%{
            top: 28%;
            opacity: 1;
        }
        100%{
            top: 24%;
            opacity: 0;
        }

    }
    @-webkit-keyframes ani34{
        0%{
            top: 32%;
            opacity: 0;
        }
        50%{
            top: 28%;
            opacity: 1;
        }
        100%{
            top: 24%;
            opacity: 0;
        }
    }
    @keyframes ani10{
        0%{
            bottom: 18%;
            opacity: 0;
        }
        50%{
            bottom: 25%;
            opacity: 1;
        }
        100%{
            bottom: 29%;
            opacity: 0;
        }
    }
    @-webkit-keyframes ani10{
        0%{
            bottom: 18%;
            opacity: 0;
        }
        50%{
            bottom: 25%;
            opacity: 1;
        }
        100%{
            bottom: 29%;
            opacity: 0;
        }
    }
    @keyframes ani11{
        0%{
            opacity: .5;
        }
        50%{
            opacity: 1;
        }
        100%{
            opacity: .5;
        }
    }
    @-webkit-keyframes ani11{
        0%{
            opacity: .5;
        }
        50%{
            opacity: 1;
        }
        100%{
            opacity: .5;
        }
    }
    /* page2 */ 
    #page2Rotate{
        position: absolute;
        width: 20.57291667%;
        right: 19.53125%;
        top: calc(28.042328% + 48px);
        animation:page2Rotate 10s linear infinite;
        -webkit-animation:page2Rotate 10s linear infinite;
    }
    /* 转动动画 */
    @keyframes page2Rotate {
        0% {
            transform:rotate(0deg);
        }
        100% {
            transform:rotate(360deg);
        }
    }
    @-webkit-keyframes page2Rotate {
        0% {
            transform:rotate(0deg);
        }
        100% {
            transform:rotate(360deg);
        }
    }
</style>
